import { userStore } from "../../stores/user.store";
import { hooksStore } from "../../stores/hooks.store";

import { getMap, pointTo } from "../../helpers/map";

import get from "get-value";
import set from "set-value";

hooksStore.addAction("ulozVrstvyDoStavu", "sideManager", ulozPridanuVrstvu);
hooksStore.addAction("nacitajUlozenyStav", "sideManager", nacitajUlozenyStav);

/**
 * Vratenie objektu ulozeneho stavu
 * @param {object} e Objekt ulozeneho stavu uzivatela
 * @returns {object}  Objekt ulozeneho stavu
 */
export function runWatch(e) {
  return get(e, "options.mapa.stav") || {};
}

/**
 * Odstranenie vrstvy z mapy aj z pamate a tym padom aj z navigacneho okienka
 * @param {string}  source_id
 * @returns  {undefined}
 */
export function odstranVrstvuZMapy(source_id) {
  const map = getMap();

  // prechadzam vsetky layery, nie sources, lebo najprv treba vymazat layer
  map.getStyle().layers.forEach(function (layer) {
    // ak ma layer spravny source, tak ho vymazem
    if (source_id === layer.source) {
      map.removeLayer(layer.id);
    }
  });

  // ak existuje source ktory mam vymazat
  if (map.getSource(source_id)) {
    map.removeSource(source_id);

    // zmazem informaciu aj z pamate stavu uzivatela
    const u = userStore.getUser();
    let stav = get(u, "options.mapa.stav", false) || {};

    if (get(stav[source_id]) !== undefined) {
      delete stav[source_id];
    }

    set(u, "options.mapa.stav", stav);

    userStore.updateUser(u);
  }
}

/**
 * Ulozenie aktualne pridanu vrstvu do storage
 * @param {object}  data Data objektu z api
 * @param {string}  source_id
 * @param {object}  sourceData
 * @param {string}  typ_vrstvy
 * @returns {undefined}
 */
export function ulozPridanuVrstvu(data, source_id, sourceData, typ_vrstvy) {
  const u = userStore.getUser();
  let stav = get(u, "options.mapa.stav", false) || {};
  if (Array.isArray(stav) && stav.length === 0) {
    stav = {};
  }
  // if (get(stav[source_id]) === undefined) {
  stav[source_id] = { data, sourceData, typ_vrstvy };
  // }
  set(u, "options.mapa.stav", stav);
  userStore.updateUser(u);
}

/**
 * Nacitanie ulozeneho stavu do mapy
 * @returns  {undefined}
 */
export function nacitajUlozenyStav() {
  const map = getMap();
  const u = userStore.getUser();

  let stav = get(u, "options.mapa.stav", false) || {};

  Object.entries(stav).forEach(([source_id, layer]) => {
    hooksStore.doAction("zobrazDataNaMape", layer.data, false);
  });
}

export function onClick(layer) {
  pointTo(layer.sourceData, layer.typ_vrstvy);
  if (layer.typ_vrstvy === "meranie") {
    return;
  }
  hooksStore.doAction(
    "nacitajDatagrid",
    hooksStore.applyFilters("resetniANastavFilter", {
      id: layer.data.id,
      type: layer.data.gistyp || layer.data.type || layer.data.typ,
      tab: layer.data.typ || "default",
    })
  );
}
